/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import PropTypes from 'prop-types';
import ReactSwitch from 'react-switch';
import common from 'constants/common';
import Loader from 'react-loader-spinner';

const SwitchWithText = ({ checked, onChange, disabled, loading }) => {
  return (
    <div className="evelyn-switch--with-text">
      {loading && (
        <div className="switch-loader">
          <Loader
            type="Oval"
            width={20}
            height={20}
            color={common.loaderColor}
          />
        </div>
      )}

      <ReactSwitch
        disabled={loading || disabled}
        onChange={onChange}
        checked={checked}
        uncheckedIcon={
          <div
            style={{
              borderRadius: 20,
              fontWeight: 'semi-bold',
              marginTop: 4,
              color: common.commonColors.gray,
              fontSize: 12,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            On
          </div>
        }
        checkedHandleIcon={
          <div
            style={{
              padding: '1px 18px',
              marginLeft: '-18px',
              borderRadius: 20,
              fontWeight: 'semi-bold',
              backgroundColor: common.commonColors.green,
              color: common.commonColors.white,
              fontSize: 12,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            On
          </div>
        }
        uncheckedHandleIcon={
          <div
            style={{
              padding: '1px 18px',
              borderRadius: 20,
              fontWeight: 'semi-bold',
              backgroundColor: common.commonColors.gray,
              color: common.commonColors.white,
              fontSize: 12,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            Off
          </div>
        }
        checkedIcon={
          <div
            style={{
              marginTop: 4,
              borderRadius: 20,
              fontWeight: 'semi-bold',
              color: common.commonColors.gray,
              fontSize: 12,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            Off
          </div>
        }
        width={82}
        height={28}
        borderRadius={20}
        handleDiameter={20}
        activeBoxShadow="0"
        offColor="transparent"
        onColor="transparent"
        offHandleColor="transparent"
        onHandleColor="transparent"
      />
    </div>
  );
};

SwitchWithText.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
};

export default SwitchWithText;
